<template>
  <v-card
    flat
    class="d-flex align-center justify-center mx-auto"
    :max-width="size"
    :max-height="size"
    :min-width="size"
    :min-height="size"
    :color="containerColor"
    style="border-radius: 4px;"
  >
    <v-icon :size="iconSize" :color="color" v-if="imagePath == ''">
      {{ icon }}
    </v-icon>
    <img v-else :src="require(`@/assets/icons/${imagePath}`)" :width="iconSize" :height="iconSize" />
  </v-card>
</template>

<script>
export default {
  props: {
    size: { type: String, default: "30" },
    color: { type: String, default: "grey" },
    icon: { type: String, default: "" },
    containerColor: { type: String, default: "transparent" },
    imagePath: { type: String, default: "" },
  },
  computed: {
    iconSize() {
      return this.size / 1.4;
      //1.6
      //#f8f8f8
    },
  },
};
</script>

<style></style>
